<template>
	<div>
		<case-form :schema="schema" class="mb6" :isBoxed="false" />

		<div class="fs4 fw7 lh125 mb2">
			If so, please give following information:
		</div>
		<j-expendable-box
			v-for="i in numberOfPeopleA"
			:key="'peopleA' + i"
			class="mb2"
		>
			<div slot="header" class="xs-12 p4 fs4 fw7 bg5 r2 b1 bc7">
				Person {{ i }}
			</div>
			<div slot="body" class="xs-12 p4 bg5 b1 bt0 bc7 r2">
				<case-form
					:schema="generateSchemaForPersonTypeA(i - 1)"
					:isBoxed="false"
				/>
			</div>
		</j-expendable-box>
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"
import JExpendableBox from "@/components/JExpendableBox"

export default {
	name: "JBProposalHomeRisk",
	components: { CaseForm, JExpendableBox },
	data() {
		return {
			numberOfPeopleA: 4
		}
	},

	computed: {
		schema() {
			return [
				{
					label:
						"8. (II) Does any Principal, Employee, Traveller or Agent take Stock at his private residence for any purpose?",
					component: "text",
					dataType: "string",
					bindTo: `case.facts.stockAtPrivateResidence`
				}
			]
		}
	},

	methods: {
		generateSchemaForPersonTypeA(index) {
			return [
				{
					label: "Select Principal, Representative, Traveler or Agent",
					component: "entityRelationship",
					entity: "case.holder",
					relation: "case.holder.relationships",
					bindTo: `case.facts.homeRiskIndividual${index}RelationshipId`
				},
				{
					label:
						"Select Principal, Representative, Traveler or Agent's Property",
					component: "entityRelationship",
					entity: {
						getEntityFromRelationship: {
							whichRelationships: "case.holder.relationships",
							caseFactTypeAsRefId: `homeRiskIndividual${index}RelationshipId`
						}
					},
					relation: {
						fieldOfEntityFromRelationship: "relationships"
					},
					bindTo: `case.facts.homeRiskIndividual${index}PropertyRelationshipId`
				},
				{
					label: "Address of property",
					component: "entityAddress",
					entity: {
						getEntityFromRelationship: {
							whichRelationships: "case.holder.relationships",
							caseFactTypeAsRefId: `homeRiskIndividual${index}RelationshipId`,
							continue: {
								caseFactTypeAsRefId: `homeRiskIndividual${index}PropertyRelationshipId`
							}
						}
					},
					// What fields we are concerned about in found entity
					relation: {
						fieldOfEntityFromRelationship: "addresses"
					},
					bindTo: `case.facts.homeRiskIndividual${index}PropertyAddressId`
				},
				{
					label: "Maximum value taken",
					component: "entityFact",
					entity: {
						getEntityFromRelationship: {
							whichRelationships: "case.holder.relationships",
							caseFactTypeAsRefId: `homeRiskIndividual${index}RelationshipId`,
							continue: {
								caseFactTypeAsRefId: `homeRiskIndividual${index}PropertyRelationshipId`
							}
						}
					},
					relation: {
						fieldOfEntityFromRelationship: "facts"
					},
					bindTo: `case.facts.homeRiskIndividual${index}PropertyMaxValueId`,
					props: {
						suggest: {
							typeIncludes: "maxValue"
						},
						createOptions: {
							type: "maxValue",
							dataType: "string"
						}
					}
				},
				{
					label: "Full Details of Safe or any other protection",
					component: "entityFact",
					entity: {
						getEntityFromRelationship: {
							whichRelationships: "case.holder.relationships",
							caseFactTypeAsRefId: `homeRiskIndividual${index}RelationshipId`,
							continue: {
								caseFactTypeAsRefId: `homeRiskIndividual${index}PropertyRelationshipId`
							}
						}
					},
					relation: {
						fieldOfEntityFromRelationship: "facts"
					},
					bindTo: `case.facts.homeRiskIndividual${index}PropertyFullDetailsId`,
					props: {
						suggest: {
							typeIncludes: "safeDetails"
						},
						createOptions: {
							type: "safeDetails",
							dataType: "string"
						}
					}
				},
				{
					label:
						"Is the property ever left unattended at the Private Dwelling House?",
					component: "entityFact",
					entity: {
						getEntityFromRelationship: {
							whichRelationships: "case.holder.relationships",
							caseFactTypeAsRefId: `homeRiskIndividual${index}RelationshipId`,
							continue: {
								caseFactTypeAsRefId: `homeRiskIndividual${index}PropertyRelationshipId`
							}
						}
					},
					relation: {
						fieldOfEntityFromRelationship: "facts"
					},
					bindTo: `case.facts.homeRiskIndividual${index}PropertyUnattendedPropertyId`,
					props: {
						// Filter out some recommended facts that should be displayed at the top of the window
						suggest: {
							// Filter all facts that includes this string in type
							typeIncludes: "unattendedProperty"
						},
						createOptions: {
							type: "unattendedProperty",
							dataType: "string"
							// value: "",

							// NOTE: not implemented, just ideas
							// component: "j-base-select", optional sometimes we don't want to pass this
							// props: {
							// 	options: this.currencies // e.g. passing options
							// },
						}
					}
				}
			]
		}
	}
}
</script>
